import React from "react"
import SaleSlider from "./SaleSlider";

const SalesPost = ({content}) => {
  
  return (
     <div className="sales-post catalog-card">
      <h3 className="catalog-card-title">
        {content.label}
      </h3>
      { content.items.length === 0 ? 
        <p className="catalog-card-empty">Sem vendas destacadss</p>
      :
        <SaleSlider 
          backgroundColor={content.background_color} 
          borderColor={content.border_color}
          textColor={content.text_color}
          sales={content.items}
        />
      }
      

    </div>
  )
}

export default SalesPost
